<template>
    
    <div>
        <StepsBar :currentStep="currentStep" />
        <!-- 其他页面内容 -->
    </div>
    <div class="background-image"></div>
    <div class="center-box">
        <h1>{{ $t('game_account_cancellation_agreement')}}</h1>
    </div>

    <div class="body-box">
        <el-scrollbar height="400px">
            <div v-html="agreementText"></div>
        </el-scrollbar>
    </div>

    <div class="center-box">
        <!-- <label>
            <input type="checkbox" v-model="agreed"> <h1>{{ $t('agreement_have_read')}}</h1>
        </label> -->
        <el-checkbox v-model="agreed" :label="$t('agreement_have_read')" size="large" />

        <el-button @click="submit" color="#626aef" :dark="isDark" :disabled="!agreed">{{ $t('agreement_next')}}</el-button>
        <!-- <button @click="submit" :disabled="!agreed"><h1>{{ $t('agreement_next')}}</h1></button> -->
    </div>
  </template>
  
<script>
import StepsBar from '@/components/StepsBar.vue';
import { setLocal } from '@/util/help.js';

export default {
    name: 'AgreementComponent',
    components: {
        StepsBar
    },
    data() {
        return {
            agreementText: "",
            agreed: false,
            currentStep: 2
        };
    },
    mounted() {
        // 异步加载文本文件
        this.loadAgreementText();
    },
    methods: {
        async loadAgreementText() {
            try {
                // 使用fetch或其他适当的方式加载文本文件内容
                const response = await fetch('/files/agreement.txt');
                const text = await response.text();

                // 将文本内容设置到agreementText
                this.agreementText = text;
            } catch (error) {
                console.error('Error loading agreement text:', error);
            }
        },
        submit() {
            if (this.agreed) {
                setLocal("read_agreement", true)
                this.$router.push("/user");
            } else {
                alert(this.$t("agreement_no"));
            }
        }
    }
};
</script>

<style>
.background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('../../public/images/back.jpg');
    background-size: cover;
    background-position: center;
    filter: none;
    z-index: -1;
}

.center-box {
    text-align: center;
    padding: 20px;
    border: 1px solid #ccc;
    background-color: #dbc08d;
    width: 1229px;
    height: 111px;
    margin: 0 auto; /* 这个属性将使元素水平居中 */
    padding-left: 20px; /* 调整缩进的大小 */
}

.body-box {
    padding: 20px;
    border: 1px solid #ccc;
    background-color: #b8d2d6;
    width: 1229px;
    margin: 0 auto; /* 这个属性将使元素水平居中 */
}
</style>
